var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-product-layout',{attrs:{"short-create-form":true,"title":"ساخت محصول","submitFunction":_vm.createProduct}})
}
var staticRenderFns = []

export { render, staticRenderFns }